export const STATUS_META = {
  NORMAL: { label: "NORMAL OPERATIONS", icon: "🟢", cls: "status-normal", short: "Normal" },
  RESTRICTED: { label: "RESTRICTED OPERATIONS", icon: "🟡", cls: "status-restricted", short: "Restricted" },
  LIMITED_VISITATION: { label: "LIMITED VISITATION", icon: "🟠", cls: "status-limited", short: "Limited visitation" },
  LOCKDOWN: { label: "LOCKDOWN", icon: "🔴", cls: "status-lockdown", short: "Lockdown" },
  VISITATION_SUSPENDED: { label: "VISITATION SUSPENDED", icon: "🔴", cls: "status-suspended", short: "Visitation suspended" },
  EMERGENCY: { label: "EMERGENCY / INCIDENT", icon: "⚠️", cls: "status-emergency", short: "Emergency" },
  UNKNOWN: { label: "STATUS UNKNOWN", icon: "⚪", cls: "status-unknown", short: "Unknown" },
};

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-US", {
      month: "short", day: "numeric", year: "numeric",
      hour: "numeric", minute: "2-digit",
    });
  } catch { return iso; }
}
